const dateFormat = new Intl.DateTimeFormat('cs-CZ', { day: 'numeric', month: 'numeric', year: 'numeric' });
const dateTimeFormat = new Intl.DateTimeFormat('cs-CZ', {
  day: 'numeric', month: 'numeric', year: 'numeric', hour: '2-digit', minute: '2-digit',
});

/** Datum bez času (`DateOnly` z API, např. `2026-11-20`). */
export function formatDate(value: string | null | undefined): string {
  if (!value) {
    return '—';
  }

  // Bez casu a zony - jinak by se pulnoc UTC v Praze posunula na predchozi den.
  const [year, month, day] = value.split('-').map(Number);
  return dateFormat.format(new Date(year!, month! - 1, day!));
}

export function formatDateTime(value: string | null | undefined): string {
  return value ? dateTimeFormat.format(new Date(value)) : '—';
}

export const priorityLabels: Record<string, string> = {
  Low: 'Nízká',
  Normal: 'Normální',
  High: 'Vysoká',
  Urgent: 'Urgentní',
};
